import i18n from '@/api/i18n/i18n';

export const SAMPLING_INTERVAL = [1, 2, 3, 5, 7, 10, 15, 30, 45, 60, 90, 120, 182, 365];

export const LIST_PACK_DATA = {
  columns: [
    {
      type: 'selection',
      title: i18n.t('settings.schedule.columns.reportName'),
      field: 'repName',
      align: 'left',
      width: 200,
      sort: 2,
      sorted: true,
      flex: 1,
    },
    {
      type: 'action',
      title: i18n.t('settings.columns.action'),
      width: 100,
      align: 'left',
      actions: [
        {
          text: i18n.t('settings.columns.actions.changeName'),
          eventName: 'changeName',
          formatter: () => '',
        },
        {
          text: i18n.t('settings.columns.actions.saveNewName'),
          eventName: 'saveNewName',
          formatter: () => '',
        },
        {
          text: i18n.t('settings.columns.actions.deleteItem'),
          eventName: 'deleteItem',
          formatter: () => '',
        },
        {
          text: i18n.t('settings.columns.actions.cancelChange'),
          eventName: 'cancelChange',
          formatter: () => '',
        },
      ],
    },
  ],
  lists: [],
  custom_field: {
    id: 'ident',
    lists: 'children',
    parent_id: 'parentId',
  },
};

export const TREE_DATA = {
  columns: [
    {
      type: 'checkbox',
      isContainChildren: true,
      title: '',
      field: 'checked',
      maxWidth: '5%',
      padding: '5px',
      align: 'left',
      flex: 3,
    },
    {
      type: 'selection',
      title: i18n.t('settings.schedule.columns.user'),
      field: 'title',
      align: 'left',
      sort: 2,
      sorted: true,
      flex: 3,
    },
    {
      title: i18n.t('settings.schedule.columns.computerName'),
      field: 'user',
      align: 'left',
      sort: 0,
      sorted: true,
      flex: 2,
    },
  ],
  lists: [],
  custom_field: {
    id: 'ident',
    lists: 'children',
    parent_id: 'parentId',
  },
};

export const INTERVAL_TYPES_ID = {
  EVERY_DAY: 1,
  EVERY_WEEK: 2,
  EVERY_MONTH: 3,
};

export const INTERVAL_TYPES = [
  {
    id: INTERVAL_TYPES_ID.EVERY_DAY,
    name: i18n.t('settings.schedule.everyDay'),
  },
  {
    id: INTERVAL_TYPES_ID.EVERY_WEEK,
    name: i18n.t('settings.schedule.everyWeek'),
  },
  {
    id: INTERVAL_TYPES_ID.EVERY_MONTH,
    name: i18n.t('settings.schedule.everyMonth'),
  },
];

export const WEEK_DAYS = [
  {
    id: 1,
    name: i18n.t('settings.schedule.monday'),
    checked: false,
  },
  {
    id: 2,
    name: i18n.t('settings.schedule.tuesday'),
    checked: false,
  },
  {
    id: 3,
    name: i18n.t('settings.schedule.wednesday'),
    checked: false,
  },
  {
    id: 4,
    name: i18n.t('settings.schedule.thursday'),
    checked: false,
  },
  {
    id: 5,
    name: i18n.t('settings.schedule.friday'),
    checked: false,
  },
  {
    id: 6,
    name: i18n.t('settings.schedule.saturday'),
    checked: false,
  },
  {
    id: 7,
    name: i18n.t('settings.schedule.sunday'),
    checked: false,
  },
];

export const FORMAT_EXPORT = {
  PDF: 'PDF',
  XLS: 'XLS',
  RTF: 'RTF',
};

export const FORMAT_MAP = {
  1: FORMAT_EXPORT.PDF,
  2: FORMAT_EXPORT.XLS,
  3: FORMAT_EXPORT.RTF,
};

export const FORMAT_VALUES = [
  {
    id: 1,
    name: FORMAT_EXPORT.PDF,
    checked: false,
  },
  {
    id: 2,
    name: FORMAT_EXPORT.XLS,
    checked: false,
  },
  {
    id: 3,
    name: FORMAT_EXPORT.RTF,
    checked: false,
  },
];

export const EMAIL_VALUE = 5;

export const NEW_REPORT_PACK = {
  emailFrom: '',
  emailLogin: '',
  emailPassword: '',
  emailTo: '',
  filter: null,
  id: 0,
  repName: i18n.t('settings.schedule.newReportPackage'),
  setInterv: 1,
  shedId: 1,
  smtp: '',
  worktime: null,
};

export const NEW_REPORTS_CONFIG = {
  startTime: '08:00:00',
  intervType: 1,
  dayMonth: 0,
};

export const MODEL_KEY = {
  ID: 'id',
  TYPE: 'type',
};
